
<template>
    <div id="Pass" class="wrap">
        <div class="pass">
            <div class="txt">
                <p>
                    SEVS의 Creator는 매 기수 별로 미디어아트를 기반으로 한 다양한 분야의 아티스트들로 구성되어 있다.
                    정기적인 미디어아트 전시를 기획하는 1명의 Curator와 8명의 Artists로 구성되어 다양한 시도와 새로운 경험을 함께 쌓아가며
                    시대정신을 담은 메시지를 전달하기 위해 네트워크를 형성합니다.
                </p>
            </div>
            <!-- <div class="title">
                <h2>Curator &#38; Artist</h2>
            </div> -->
            <div class="accordion accordion-flush" id="accordionFlushExample">
                <!-- 15기 셉스 -->
                <li v-for="item in passList15" :key="item.title"> 
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading15">
                            <button class="accordion-button collapsed " type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse15" aria-expanded="false" aria-controls="flush-collapse15">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse15" class="accordion-collapse collapse" aria-labelledby="flush-heading15" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body" style="padding-bottom: 45%;"> 
                                <div class="artists" v-for="(item, index) in imgitems" :key="index" v-b-modal.ArtistsModal>
                                    <button class="imgbox" @click="changeImage(item)">
                                        <img :src="item.thumbnail">
                                        <p style="margin: 10px; text-align: center;">{{item.name}}</p>
                                        <!-- <p style="font-size:14px; ">{{item.activity}}</p> -->
                                    </button>   
                                </div>
                                <ul>
                                    <!-- <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>
                                            <img src="@/assets/image/15기/임휘재 큐레이터.jpg"> 
                                            <p>{{name[0]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>
                                            <img src="@/assets/image/15기/김규년 아티스트.jpg"> 
                                            <p>{{name[1]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                
                                            <img src="@/assets/image/15기/김동우 아티스트.jpg">
                                            <p>{{name[2]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                  
                                            <img src="@/assets/image/15기/김휘아 아티스트.jpg">
                                            <p>{{name[3]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                
                                            <img src="@/assets/image/15기/윤지영 아티스트.jpg">
                                            <p>{{name[4]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                  
                                            <img src="@/assets/image/15기/이영미 아티스트.jpg">
                                            <p>{{name[5]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                
                                            <img src="@/assets/image/15기/이을 아티스트.jpg">
                                            <p>{{name[6]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                 
                                            <img src="@/assets/image/15기/좌진규 아티스트.jpg">
                                            <p>{{name[7]}}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="artists"  @click="changeImage(list)" v-b-modal.ArtistsModal>                                  
                                            <img src="@/assets/image/15기/박세연 아티스트.jpg">
                                            <p>{{name[8]}}</p>
                                        </div>
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                </li>
                <!-- 8기 -- 14기 셉스 -->
                <li v-for="item in passList14" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading14">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse14" aria-expanded="false" aria-controls="flush-collapse14">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse14" class="accordion-collapse collapse" aria-labelledby="flush-heading14" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
                <li v-for="item in passList13" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading13">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse13" aria-expanded="false" aria-controls="flush-collapse13">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse13" class="accordion-collapse collapse" aria-labelledby="flush-heading13" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
                <li v-for="item in passList12" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading12">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse12" aria-expanded="false" aria-controls="flush-collapse12">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse12" class="accordion-collapse collapse" aria-labelledby="flush-heading12" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
                <li v-for="item in passList11" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading11">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse11" aria-expanded="false" aria-controls="flush-collapse11">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse11" class="accordion-collapse collapse" aria-labelledby="flush-heading11" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
                <li v-for="item in passList10" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading10">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse10" aria-expanded="false" aria-controls="flush-collapse10">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse10" class="accordion-collapse collapse" aria-labelledby="flush-heading10" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
                <li v-for="item in passList9" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading9">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse9" aria-expanded="false" aria-controls="flush-collapse9">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse9" class="accordion-collapse collapse" aria-labelledby="flush-heading9" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
                <li v-for="item in passList8" :key="item.title">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="flush-heading8">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse8" aria-expanded="false" aria-controls="flush-collapse8">
                                {{item.title}}
                            </button>
                        </h2>
                        <div id="flush-collapse8" class="accordion-collapse collapse" aria-labelledby="flush-heading8" data-bs-parent="#accordionFlushExample">
                            <div class="accordion-body">
                                <p>Artist</p> {{item.name}} 
                            </div>
                        </div>
                    </div>
                </li>
            </div>

            <b-modal id="ArtistsModal" size="xl" centered hide-footer>
                <div class="imgbox">
                    <!-- <img :src="require(`@/assets/image/15기/${imgbox}.jpg`)"> -->
                    <img :src="selected.item">
                </div>
                <!-- <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <img :src="selected.item" class="d-block w-100" alt="...">
                        </div>
                        <div class="carousel-item">
                            <img src='@/assets/image/15기/portfolio/2.png' class="d-block w-100" alt="...">
                        </div>
                        <div class="carousel-item">
                            <img src='@/assets/image/15기/portfolio/3.png' class="d-block w-100" alt="...">
                        </div>
                    </div>

                    <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Previous</span>
                    </button>
                    <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <span class="visually-hidden">Next</span>
                    </button>
                </div> -->
            </b-modal>
        </div>
    </div>
</template>

<script>
import { board } from '@/mixins/board.js';
 
export default {
    mixins:[board],

    data() {``
        return{
            // name : ['임휘재','김규년','김동우','김휘아','윤지영','이영미','이을','좌진규','박세연'],
            // list: ['임휘재 큐레이터','김규년 아티스트','김동우 아티스트','김휘아 아티스트','박세연 아티스트','윤지영 아티스트','이영미 아티스트','이을 아티스트','좌진규 아티스트']
            selected: "selected.item",
            imgitems: [
                {thumbnail: require('@/assets/image/15기/임휘재 큐레이터.jpg'), item: require('@/assets/image/15기/portfolio/1.png'), name: '임휘재'},
                {thumbnail: require('@/assets/image/15기/김규년 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/2.png'), name: '김규년'},
                {thumbnail: require('@/assets/image/15기/김동우 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/3.png'), name: '김동우'},
                {thumbnail: require('@/assets/image/15기/김휘아 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/4.png'), name: '김휘아'},
                {thumbnail: require('@/assets/image/15기/박세연 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/5.png'), name: '박세연'},
                {thumbnail: require('@/assets/image/15기/윤지영 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/6.png'), name: '윤지영'},
                {thumbnail: require('@/assets/image/15기/이을 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/7.png'), name: '이을'},
                {thumbnail: require('@/assets/image/15기/이영미 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/8.png'), name: '이영미'},
                {thumbnail: require('@/assets/image/15기/좌진규 아티스트.jpg'), item: require('@/assets/image/15기/portfolio/9.png'), name: '좌진규'},
            ]
        }
    },
    methods: {
        changeImage(selected) {
            this.selected = selected
        }
    }
}
</script>


<style lang="scss">
#Pass{
    .pass {
        .txt{
            p{font-size: 20px; margin-top: 8%; line-height: 2; word-spacing: 2px; letter-spacing: 2px; font-weight: 500;}
        }
        li{margin-bottom: 2%;}
        p {font-size: 20px; font-weight: 700; margin: 20px 0 10px 0; display: block;}
        .title{margin: 90px 0 0 0;}
        .accordion{margin-top: 5%;  margin-bottom: 20%; font-size: 19px; word-spacing: 25px; letter-spacing: 3px;}
        // .accordion-body{padding-top: 0px;}
        .accordion-button{font-size: 20px; font-weight: 600; border-bottom: 1px solid rgb(177, 175, 175);}
        .accordion-body{padding: auto;
            .artists{width: 100%; display: block; width: 20%; float: left;
                img{display: block; width: 100%; height: 100%; padding: 15px; cursor: pointer;}
                // p{display: block; text-align: center; cursor: pointer;}        
            }
        }
    }
}
#ArtistsModal {
    .modal-body{padding: 0;}
}
@media(max-width:767px){
    #Pass{
        .pass{ padding-bottom: 50%; padding-left: 10px; padding-right: 10px;
            .title{margin: 10px 0 0 10px; 
                h2{margin-bottom: 0rem;}
            }
            .txt{
                p{font-size: 14px; margin-top: 8%; line-height: 2; word-spacing: 2px; letter-spacing: 2px; font-weight: 500;}
            }
            .accordion{margin-top: 8%;  margin-bottom: 23%; font-size: 14px; word-spacing: 5px; letter-spacing: 3px;}
            // .accordion-body{padding-top: 0px;}
            .accordion-button{font-size: 16px; font-weight: 600;}
            .accordion-body{
                .artists{width: 100%; display: block; width: 20%; float: left;
                    img{display: block; width: 100%; height: 100%; padding: 5px; cursor: pointer;}
                    p{display: block; text-align: center; cursor: pointer; font-size: 13px;}        
                }
            }
        }
    }
    #ArtistsModal {
        .modal-header{padding: 0;}
        .modal-body{padding: 0;}
    }
}
</style>